import type { FunctionComponent } from 'react';
import map from 'lodash/map';
import ReactTooltip from 'react-tooltip';
import { formatCurrency } from '../../utils/currency';
import * as styles from '../Section.module.css';
import * as creditStyles from './Credits.module.css';

const CREDITS_DATA_TIP = `Your available credits are detailed below. For additional information on credits, please 
  <a href='https://support.fabfitfun.com/en/articles/57-how-does-credit-work'
  target='_blank'>click here</a>.`;

type CreditsProps = {
  credits: {
    amount: number;
    creditName: string;
  }[];
};

const Credits: FunctionComponent<CreditsProps> = ({ credits = null }) => {
  if (!credits) return null;

  return (
    <>
      <div data-testid="credits-discount-section">
        <div className={`${styles.header} ${styles.headerLeft}`}>
          <span>Credits & Discounts</span>
          <i
            className="fas fa-info-circle"
            data-tip={CREDITS_DATA_TIP}
            data-for="credits"
            data-delay-hide="2000"
          />
        </div>
        <div className={`${styles.readOnlyContainer} ${creditStyles.container}`}>
          <ul>
            {map(credits, (credit) => {
              const { creditName, amount } = credit;
              return (
                <li key={creditName} className={creditStyles.item}>
                  <span>{`${creditName}:`}</span>
                  {formatCurrency(amount / 100)}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <ReactTooltip
        id="credits"
        className={creditStyles.tooltip}
        place="top"
        type="dark"
        effect="solid"
        globalEventOff="click"
        html
      />
    </>
  );
};

export default Credits;
